// extracted by mini-css-extract-plugin
module.exports = {"image":"style-module--image--2Bffn"};